import React from "react";
import styled from "styled-components";
import { C3Text, C4Text, T3Text } from "../text/CustomText";
import { Theme } from "../../Theme";
import { Column, Row, SizedBox } from "../CommonBaseComponents";

const UsageRateTableTooltip = () => {
    return (
        <CardContainer>
            <Row width={"100%"} alignItem={"flex-start"} justifyContent={"space-between"}>
                <Column alignItem={"flex-start"}>
                    <C4Text fontColor={Theme.text.zinc850} fontWeight={"500"}>
                        06-07 / 2pm - 4pm
                    </C4Text>
                    <SizedBox height={"6px"} />
                    <T3Text fontWeight={"500"}>Total 535</T3Text>
                </Column>

                <SizedBox
                    width={"auto"}
                    height={"28px"}
                    padding={"5px 6px"}
                    backgroundColor={Theme.color.indigo500_007}
                    borderRadius={"6px"}
                >
                    <C3Text fontColor={Theme.color.indigo500} fontWeight={"500"}>
                        12.2%
                    </C3Text>
                </SizedBox>
            </Row>
            <SizedBox height={"12px"} />
            <StatsGrid>
                <StatItem $color={Theme.color.cyan500}>
                    <Label>Washer</Label>
                    <Value>222</Value>
                </StatItem>

                <StatItem $color={Theme.color.orange500}>
                    <Label>Dryer</Label>
                    <Value>313</Value>
                </StatItem>

                <StatItem $color={Theme.color.indigo500}>
                    <Label>Combo</Label>
                    <Value>150</Value>
                </StatItem>
            </StatsGrid>
        </CardContainer>
    );
};

// Styled Components
const CardContainer = styled.div`
    width: 186px;
    background: ${Theme.color.white};
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 10px 30px ${Theme.color.black_05};
`;

const StatsGrid = styled.div`
    display: flex;
    justify-content: space-between;
`;

const StatItem = styled.div`
    position: relative;
    padding-left: 12px;
    flex: 1;

    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 15%;
        bottom: 15%;
        width: 3px;
        background-color: ${({ $color }) => $color};
        border-radius: 2px;
    }
`;

const Label = styled.div`
    font-size: 12px;
    color: ${Theme.color.gray500};
    font-weight: 400;
    margin-bottom: 4px;
    font-family: ${Theme.text.default.fontFamily};
`;

const Value = styled.div`
    font-size: 15px;
    font-weight: 600;
    color: ${Theme.color.zinc850};
    font-family: ${Theme.text.default.fontFamily};
`;

export default UsageRateTableTooltip;
